import { Avatar, IconButton } from '@mui/material';
import { AccordionArrowIcon } from 'Images';
import { useDictionary } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

interface IAccordionArrow {
  isOpen?: boolean;
}

export const AccordionArrow = (props: IAccordionArrow) => {
  const generalDictionary = useDictionary(Dictionary, DICTIONARY.General);

  return (
    <IconButton>
      <Avatar
        src={AccordionArrowIcon}
        sx={{
          width: '20px',
          height: '20px',
          transform: props.isOpen ? `rotate(180deg)` : `rotate(0deg)`,
          transition: 'transform 0.3s',
        }}
        alt={''}
      />
    </IconButton>
  );
};
